import { useMemo } from 'react';

import { MEETING_NOTES_TO_OWNER_ASSOCIATION } from '@/lib/crm/utils/meetingNotes';
import type { CrmObject } from '@/types/crm';

/**
 * Resolves each meeting note's owning user via its direct
 * ahoy_meeting_notes_to_owner association.
 *
 * Returns a map of noteEntityId -> ownerUserEntityId, including only notes
 * whose owner edge is present.
 */
export function useMeetingNoteOwners(notes: CrmObject[]): Map<string, string> {
  return useMemo(() => {
    const result = new Map<string, string>();
    for (const note of notes) {
      const edge = note.associations?.find(
        a => a.association_type_name === MEETING_NOTES_TO_OWNER_ASSOCIATION
      );
      if (edge?.target_entity_id && note.entity_id) {
        result.set(note.entity_id, edge.target_entity_id);
      }
    }
    return result;
  }, [notes]);
}
